"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    loaderWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: spacing(8)
    },
    gridWrapper: {
      paddingBottom: spacing(4)
    }
  };
});

var SelectItemsList = function SelectItemsList(_ref2) {
  var _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? [] : _ref2$children,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$isLoaded = _ref2.isLoaded,
      isLoaded = _ref2$isLoaded === void 0 ? false : _ref2$isLoaded;
  var classes = useStyles();
  var items = (0, _react.useMemo)(function () {
    return children.map(function (element) {
      return /*#__PURE__*/(0, _react.cloneElement)(element, element.props);
    });
  }, [children]);

  var _useState = (0, _react.useState)(items.length <= 5),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showAll = _useState2[0],
      setShowAll = _useState2[1];

  var itemsToShow = (0, _react.useMemo)(function () {
    return showAll ? items : items.slice(0, 5);
  }, [items, showAll]);
  var showButton = items.length > 0 && !showAll && !isLoading && isLoaded;
  (0, _react.useEffect)(function () {
    setShowAll(items.length <= 5);
  }, [items]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "CreateGift-CampaignsLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null))), !isLoading && isLoaded && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "CreateGift-CampaignList"
  }, /*#__PURE__*/_react.default.createElement(_material.Slide, {
    in: true,
    direction: "left"
  }, /*#__PURE__*/_react.default.createElement("div", null, itemsToShow))), showButton && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.gridWrapper,
    container: true,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return setShowAll(true);
    }
  }, "Show ", items.length - itemsToShow.length, " more")));
};

var _default = SelectItemsList;
exports.default = _default;